<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"> கலந்தாய்வு கூட்டம்</span>
      <button (click)="close()" mat-icon-button class="button" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>


  <div mat-dialog-content class="p-16 pb-0 m-0" fusePerfectScrollbar>
    <div class="m-12" style="width: 100%;" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
      <div style="width: 100%;" class="p-12 primary-A200">
        <div class='notes'>
          <div class='row mt-12' *ngFor="let note of Status">
            <div class='column'>
              <div class='text'>
                {{note.id}} . {{note.notes}}
              </div>
            </div>
            <div class='column1'>
              <div class=''>
                <mat-checkbox class="example-margin" type="checkbox" [checked]="getAnswer(note.id)"
                  (change)="changeSelection($event, note)" *ngIf="showCheck"></mat-checkbox>
                <div class="states" *ngIf="!showCheck">
                  <mat-icon *ngIf="getAnswer(note.id)" class="example-margin" style="color:green;">check</mat-icon>
                  <mat-icon *ngIf="!getAnswer(note.id)" class="example-margin" style="color:red;">clear</mat-icon>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div fxFlex="100">
        <div class="box p-12">
          <div *ngFor="let list of member_list">
            <mat-card class="example-card p-12 m-12">
              <mat-card-header>
                <div mat-card-avatar class="example-header-image">
                  <img (error)="showEmptyProfile($event)" src="{{list.member_photo_url}}" />
                </div>
                <mat-card-title>{{list.member_name}}</mat-card-title>
                <mat-card-subtitle>{{list.member_id}}</mat-card-subtitle>
              </mat-card-header>
              <mat-checkbox *ngIf="showCheck" class="example-margin" [checked]="getPorupalargal(list)"
                (change)="changeAttendance($event, list)"></mat-checkbox>
              <div class="states" *ngIf="!showCheck">
                <mat-icon *ngIf="getPorupalargal(list)" class="example-margin" style="color:green;">check</mat-icon>
                <mat-icon *ngIf="!getPorupalargal(list)" class="example-margin" style="color:red;">clear</mat-icon>
              </div>

            </mat-card>
          </div>
        </div>

      </div>

      <div fxFlex="100" class="footer">
        <button class="mr-4 accent" (click)="mathakanaku()" mat-raised-button color="primary">மாத கணக்கு அறிக்கை முடிக்க</button>
        <button class="green-600" (click)="save()" [disabled]="isSelected()" mat-raised-button
          color="primary">முடிக்கவும்</button>
      </div>

    </div>
  </div>


</div>